import { MessageSquare, Search, Package, Ship } from "lucide-react";
import useIntersectionObserver from "../hooks/useIntersectionObserver";
import Reveal from "./Reveal";

const STEPS = [
  {
    icon: MessageSquare,
    title: "Inquiry & Sample Request",
    desc: "Share your requirements and request product samples.",
  },
  {
    icon: Search,
    title: "Sourcing & Quality Check",
    desc: "We source from verified suppliers and inspect every batch.",
  },
  {
    icon: Package,
    title: "Production & Private Labeling",
    desc: "Custom branding, packaging, and OEM production at scale.",
  },
  {
    icon: Ship,
    title: "Export & Delivery",
    desc: "Documentation, logistics, and delivery to your port or door.",
  },
];

export default function ProcessTimeline() {
  const [lineRef, lineInView] = useIntersectionObserver({ threshold: 0.25, once: true });

  return (
    <section className="section-shell relative overflow-hidden">
      <div className="gradient-mesh pointer-events-none">
        <div className="gradient-blob w-[400px] h-[400px] bg-accent/20 -left-32 top-0 animate-blob-drift" />
        <div className="gradient-blob w-[350px] h-[350px] bg-accent-2/15 right-0 bottom-0 animate-blob-drift-2" />
      </div>

      <div className="section-inner relative z-10">
        <Reveal>
          <div className="text-center mb-8 md:mb-10">
            <p className="label-cap text-accent mb-2">Our Process</p>
            <h2 className="font-serif text-3xl md:text-5xl font-bold text-primary">How We Work</h2>
          </div>
        </Reveal>

        <div ref={lineRef} className="relative">
          {/* Desktop horizontal line */}
          <div className="hidden md:block absolute top-8 left-[12%] right-[12%] h-0.5 bg-border overflow-hidden rounded-full">
            <div
              className="h-full bg-accent origin-left transition-transform duration-[2000ms] ease-out"
              style={{ transform: lineInView ? "scaleX(1)" : "scaleX(0)" }}
            />
          </div>

          <div className="grid md:grid-cols-4 gap-10 md:gap-6">
            {STEPS.map((step, i) => {
              const Icon = step.icon;
              return (
                <Reveal key={step.title} delay={i * 120}>
                  <div className="relative flex flex-col items-center text-center md:items-start md:text-left">
                    <div className="w-16 h-16 rounded-full border-2 border-accent bg-surface flex items-center justify-center mb-4 relative z-10">
                      <span className="absolute -top-1 -right-1 w-6 h-6 rounded-full bg-accent text-primary text-xs font-bold flex items-center justify-center">
                        {i + 1}
                      </span>
                      <Icon size={22} className="text-accent" />
                    </div>
                    <h3 className="font-serif text-lg font-bold text-primary">{step.title}</h3>
                    <p className="mt-2 text-sm text-muted leading-relaxed">{step.desc}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
